import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  IconButton, List, ListItem, ListItemButton, ListItemText,
  Modal,
  Slide,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import InputForm from "../../form/InputForm";
import React, {useContext} from "react";
import {styled} from "@mui/material/styles";
import GenericAddItem from "../../../layouts/GenericInput/GenericAddItem";
import Iconify from "../../Iconify";
import {GlobalContext} from "../../../providers/GlobalProvider";
import {ErrorHandler} from "../../../utils/ErrorHandler";
import {useSnackbar} from "notistack";

const StyledCard = styled(Card)({
  margin: '15px auto',
  width: 400,
  bgcolor: 'background.paper',
});

export default function AddSequenceAssignment({ inputs, title, open, many, seqIndex, onSubmit, handleModalClose }) {
  const {enqueueSnackbar} = useSnackbar();
  const [startNumber, setStartNumber] = React.useState(seqIndex);
  const [numSequences, setNumSequences] = React.useState(10)
  const [assignments, setAssignments] = React.useState([])
  const [addAnother, setAddAnother] = React.useState(false)

  React.useEffect(() => {
    if (seqIndex) {
      setStartNumber(seqIndex + 2)
    }
  }, [seqIndex])

  const handleStartNumberChange = (e) => {
    setStartNumber(e.target.value)
  }

  const handleNumSeqChange = (e) => {
    setNumSequences(e.target.value)
  }

  const handleAddAssignment = (form) => {
    form.trigger().then((isValid) => {
      if (!isValid) return;

      setAssignments([...assignments, form.getValues()]);
      setAddAnother(false);
      form.reset();
    });
  }

  const removeAssignment = (index) => () => {
    setAssignments(assignments.filter((_, i) => i !== index));
  }

  const handleSubmit = (form) => {
    if (assignments.length === 0) {
      ErrorHandler.enqueueError(
          'You must add at least one assignment.',
          enqueueSnackbar
      );

      return;
    }
    const payload = {
      startNumber,
      numSequences,
      assignments: [...assignments]
    }

    return onSubmit(payload).then(() => {
      setAssignments([]);
    });
  }

  return (
      <Modal open={open} onClose={handleModalClose} sx={{ overflow: 'auto' }}>
        <Slide in={open}>
          <StyledCard>
            <CardHeader title={`Add ${title}`} />
            <CardContent>
              <Stack spacing={2}>
                { many && (
                    <Stack spacing={2}>
                      <Typography variant="subtitle2">Sequence Settings</Typography>
                      <TextField type="number" label="Start at Sequence" value={startNumber} onChange={handleStartNumberChange} />
                      <TextField type="number" label="How Many" value={numSequences} onChange={handleNumSeqChange} />
                      {assignments.length > 0 && (
                          <Stack spacing={1} width="100%">
                            <Typography variant="subtitle2">Assignments</Typography>
                            <List>
                              {assignments.map((assignment, index) => (
                                  <ListItem key={index} secondaryAction={(
                                      <IconButton edge="end" size="small" aria-label="delete" onClick={removeAssignment(index)}>
                                        <Iconify icon="ep:close-bold" />
                                      </IconButton>
                                  )}>
                                    <ListItemText variant="body2">{assignment.name.replace('{}', '{number}')}</ListItemText>
                                  </ListItem>
                              ))}
                            </List>
                          </Stack>
                      )}
                    </Stack>
                )}
                <Stack spacing={2}>
                  { many ? (
                      <>
                        {assignments.length === 0 || addAnother ? (
                            <>
                              <Stack spacing={1}>
                                <Typography variant="subtitle2">Assignment Settings</Typography>
                                <Typography variant="caption">
                                  use <code>{"{}"}</code> as a placeholder in the Name and Instructions field to
                                  indicate where you want the counting value to be. For example: "Read Chapter <code>{"{}"}</code>"
                                  would look like, "Read Chapter 4" if the Start Sequence above was at 4.
                                </Typography>
                              </Stack>
                              <GenericAddItem
                                  inputs={inputs}
                                  hasContainer={false}
                                  customButtons={(form) => (
                                      <Stack direction="row" justifyContent={assignments.length > 0 ? "space-between" : "flex-end"} alignItems="center">
                                        {assignments.length > 0 && (
                                            <Button variant="text" onClick={() => setAddAnother(false)}>Cancel</Button>
                                        )}
                                        <Button variant="contained" onClick={() => handleAddAssignment(form)}>Add Assignment</Button>
                                      </Stack>
                                  )}
                              />
                            </>
                        ) : !addAnother ? (
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                              <Button variant="text" onClick={() => setAddAnother(true)}>Add Another</Button>
                              <Button variant="contained" onClick={() => handleSubmit()}>Submit</Button>
                            </Stack>
                        ) : null}

                      </>
                  ) : (
                      <GenericAddItem inputs={inputs} createAction={onSubmit} hasContainer={false} />
                  )}
                </Stack>
              </Stack>
            </CardContent>
          </StyledCard>
        </Slide>
      </Modal>
  )
}